// extracted by mini-css-extract-plugin
module.exports = {"attachments":"SendModal_attachments__Ew_jC"};